module.exports = __webpack_public_path__ + "static/media/welcomhome-oc-horizontal.288feea4.png";